const Recharge = {

    // PAGE HEADER
    "recharge": "Recharge",
    "plan_purchase_history": "Purchase History Request Details",

    // FIELDS
    "plan_type": "Plan Type",
    "ph_plan_type": "Select Plan Type",
    "plan_details": "Plan Details",
    "validity": "Validity",
    "price": "Price",
    "tax": "Tax",
    "total": "Total",
    "buy": "Buy",
    "vas": "Value Added Service",
    "payment_method": "Select Payment Method",
    "proceed": "Proceed to payment",
    "payable": "payable :",
    "default_view": "Default View",
    "lightning_view": "Lightning View",
    "choose_plan": "Choose Plan",
    "view_more_plans": "View more Plans",
    "view_details": "View Details",
    "compare": "Compare",
    "compare_plans": "Compare Plans",
    "compare_hint": "Select one more plan (from any tab) to compare",
    "compare_max": "You can compare up to {{count}} plans",
    "compare_best": "Best value in the row",
    "current_plan": "Current Plan",
    "clear": "Clear",
    "data": "Data",
    "normal_speed": "Normal Speed",
    "post_fup_speed": "Post FUP Speed",
    "data_category": "Data Category",
    "upto": "Upto",
    "days": "days",
    "select_ott": "Select OTT",
    "select_voice": "Select Voice",
    "select_iptv": "Select IPTV",
    "start_date": "Start Date",
    "end_date": "End Date",
    "payment_status": "Payment Status",
    "ph_payment_status": "Select Payment Status",
    "order_type": "Order Type",
    "ph_order_type": "Select Order Type",

    // VALIDITY TABS
    "tab_1": "1 Month",
    "tab_3": "3 Months",
    "tab_6": "6 Months",
    "tab_12": "1 Year",
    "tab_other": "Other",

    // MESSAGES (same text as portal)
    "plan_not_available_msg": "Your Existing Plan is not available any more. Please select a New Plan.",
    "payment_msg": "Please make the payment to start enjoying all the features of our plan as soon as possible",
    "plan_not_available": "Plan not available!",
    "select_plan_type": "Please select plan type",
    "select_pg": "Please Select One Payment Gateway",
    "select_vas": "Please Select Value Added Service",
    "not_eligible_vb": "* You are not eligible to purchase \"Volume Booster\"",
    "not_allowed": "You're not allowed to recharge,Please contact administrator.",
    "order_placed": "Order placed successfully",

    // PAYMENT GATEWAY (same text as portal)
    "payment_title": "Payment",
    "payment_ref": "Your Payment Reference Number is :",
    "payment_redirect_wait": "Please wait you will be redirected to payment gateway in",
    "payment_seconds_auto": "seconds automatically",
    "payment_redirect_manual": "if you want to redirect manually",
    "click_here": "Click Here",
    "payment_success": "Your payment is successfully, Please refer recharge section for purchase details",
    "payment_failed": "Your payment is failed, Please try again with another payment method(s)",
    "payment_in_progress": "Your payment is still in progress, Please refer recharge section for final status after some time",
    "go_dashboard": "Go to Dashboard",
    "payment_processing": "Please wait your payment is under process...",
    "payment_processing_hint": "If your payment status is not reflected, you can check status from customer portal after some time....",
    "txn_successful": "Your transaction for {{id}} has successful.",
    "txn_failed": "Your transaction for {{id}} has Failed.",
    "txn_pending": "Your transaction for {{id}} is still pending. Please check the status from the customer portal after some time.",
    "redirect_dashboard_in": "You will be redirected to Dashboard in {{sec}} second(s)",
    "redirect_manually": "click here to redirect manually",
    "invalid_payment_link": "Invalid payment reference.",

    // TABLE HEADER (Plan Purchase History)
    "table_purchase_date": "PURCHASE DATE",
    "table_payment_status": "PAYMENT STATUS",
    "table_amount": "AMOUNT",
    "table_trans_id": "TRANS ID",
    "table_pg_name": "PG NAME",

}

export default Recharge;
